import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BuildingService } from 'app/modules/customer-details/building/building.service';
import { FeatureCollection } from 'app/modules/models/stateAdress.type';
import { debounceTime } from 'rxjs';

@Component({
    selector: 'app-address-autocomplete',
    templateUrl: './address-autocomplete.component.html',
})
export class AddressAutocompleteComponent implements OnInit {

    addressAutocompleteFrom: UntypedFormGroup;
    options: FeatureCollection;
    filteredOptions: FeatureCollection;
    enableSubmitButton: boolean = false;
    currentAddress: string = '';
    mainAddress: any;


    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<AddressAutocompleteComponent>,
        private _buildingService: BuildingService,
        private _formBuilder: UntypedFormBuilder) { }

    ngOnInit(): void {
        this.addressAutocompleteFrom = this._formBuilder.group({
            address: [''],
        });

        this.addressAutocompleteFrom
            .get('address')
            .valueChanges.pipe(debounceTime(1000))
            .subscribe(value => {
                if (value !== null && value !== undefined && value !== '') {
                    this._buildingService.getAddress(value).subscribe((result: FeatureCollection) => {
                        this.options = result;
                        this.filteredOptions = this.options;
                    });
                }
            });
    }

    closeModal(): void {
        // Close the modal
        this.dialogRef.close();
    }

    validateAddress(): void {        
        this.dialogRef.close(this.mainAddress);
    }

    selectedOption(event) {
        this.mainAddress = event;
        let address = event.option.value
        this.currentAddress = address?.properties?.label ? address.properties.label : "";
        this.addressAutocompleteFrom.get('address').setValue(this.currentAddress);
        this.enableSubmitButton = this.currentAddress?.length > 0 ? true : false;
        
    }
}